import { createAction } from '@reduxjs/toolkit';

import {
  MESSAGES_DETAIL_RESET,
  MESSAGES_DETAIL_GET_START,
  MESSAGES_DETAIL_GET_SUCCESS,
  MESSAGES_DETAIL_GET_FAILURE,
  MESSAGES_ATTACHMENT_GET_REQUEST,
  MESSAGES_SET_READ_REQUEST,
  MESSAGES_SET_READ_SUCCESS,
  MESSAGES_SET_READ_FAILURE,
  MESSAGES_SET_ARCHIVED_REQUEST,
  MESSAGES_SET_ARCHIVED_SUCCESS,
  MESSAGES_SET_ARCHIVED_FAILURE,
  MESSAGES_ADD_PARTICIPANTS_REQUEST,
  MESSAGES_ADD_PARTICIPANTS_SUCCESS,
  MESSAGES_ADD_PARTICIPANTS_FAILURE,
  MESSAGES_CREATE_REQUEST,
} from './messagesDetail.const';

export const messagesDetailResetAction = createAction(MESSAGES_DETAIL_RESET);

export const messagesDetailGetStartAction = createAction(MESSAGES_DETAIL_GET_START);
export const messagesDetailGetSuccessAction = createAction(MESSAGES_DETAIL_GET_SUCCESS);
export const messagesDetailGetFailureAction = createAction(MESSAGES_DETAIL_GET_FAILURE);

export const messagesAttachmentGetRequestAction = createAction(MESSAGES_ATTACHMENT_GET_REQUEST);

export const messagesSetReadRequestAction = createAction(MESSAGES_SET_READ_REQUEST);
export const messagesSetReadSuccessAction = createAction(MESSAGES_SET_READ_SUCCESS);
export const messagesSetReadFailureAction = createAction(MESSAGES_SET_READ_FAILURE);

export const messagesSetArchivedRequestAction = createAction(MESSAGES_SET_ARCHIVED_REQUEST);
export const messagesSetArchivedSuccessAction = createAction(MESSAGES_SET_ARCHIVED_SUCCESS);
export const messagesSetArchivedFailureAction = createAction(MESSAGES_SET_ARCHIVED_FAILURE);

export const messagesAddParticipantsRequestAction = createAction(MESSAGES_ADD_PARTICIPANTS_REQUEST);
export const messagesAddParticipantsSuccessAction = createAction(MESSAGES_ADD_PARTICIPANTS_SUCCESS);
export const messagesAddParticipantsFailureAction = createAction(MESSAGES_ADD_PARTICIPANTS_FAILURE);

export const messagesCreateRequestAction = createAction(MESSAGES_CREATE_REQUEST);
